import React from "react";

export default function TitleBar({ title }) {
  return (
    <section className="content-header pt-4 px-0">
      <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="position-relative w-100 title-page-container">
            <div className="position-absolute border border-1 border-dark py-2 px-3 title-page">
              {title}
            </div>
            <div className="hr-title-page"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
